export default "__VITE_ASSET__CY6Sfymn__"